import Header from './Header/Header';
import React, { useEffect, useState } from 'react';
import { fetchAccountInfo } from '../actions/accountInfo.actions';
import { fetchEmployeeData } from '../actions/employee.action';
import { setUserLanguage } from '../utils/language';
import { useDispatch, useSelector } from 'react-redux';
import { NAVIGATION_DRAWER_WIDTH } from '../utils/const';
import { Box, useMediaQuery, useTheme } from '@material-ui/core';
import GroupObjectives from './Objectives/GroupObjectives';
import Filters from './Filters/Filters';
import FilterProvider from './Filters/FilterProvider';

const GroupObjectivePage = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up('sm'));

  const [ drawerOpen, setDrawerOpen ] = useState(false);

  const employee = useSelector(state => state.employee);

  useEffect(() => {
    dispatch(fetchAccountInfo());
    if (JSON.stringify(employee) === '{}') {
      dispatch(fetchEmployeeData()).then(employee => {
        setUserLanguage(employee?.language);
      });
    }
  }, [ dispatch, employee ]);

  return (
    <FilterProvider>
      <Header drawerOpen={ drawerOpen } setDrawerOpen={ setDrawerOpen } />
      <div style={ {
        marginLeft: !sm ? 'auto' : drawerOpen ? `${NAVIGATION_DRAWER_WIDTH}px` : '55px'
      } }>
        <Box m={ 2 }>
          <Filters />
        </Box>
        <GroupObjectives />
      </div>
    </FilterProvider>
  );
};

export default GroupObjectivePage;